import React, { useState } from "react";

import {
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Paper,
  TextField,
  Link,
  SwipeableDrawer,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
  toggleForgotPassword,
  toggleLogin,
  toggleSignUp,
} from "../../features/modals/modalSlice";
import {
  AccountCircle,
  MailOutline,
  Email,
  Password,
} from "@mui/icons-material";
import { loginUser } from "../../features/Auth/authSlice";
import ForgotPassword from "./ForgotPassword";
import { Container } from "@mui/system";

const Login = () => {
  const [logs, setLogs] = useState({
    email: "",
    password: "",
  });
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const { loginModal } = useSelector((state) => state.modal);
  const { errorMsg } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const handleOpenLogin = () => {
    dispatch(toggleLogin());
  };

  const handleChange = (e) => {
    setLogs({
      ...logs,
      [e.target.name]: e.target.value,
    });
  };

  const handleOpenForgotPassword = () => {
    dispatch(toggleLogin());
    dispatch(toggleForgotPassword());
  };

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    dispatch(loginUser(logs));
    // document.getElementById("loginForm").reset();
  };

  return (
    <>
      {/* <pre>{JSON.stringify(logs)}</pre> */}
      <SwipeableDrawer anchor="top" open={loginModal} onClose={handleOpenLogin}>
        <Container maxWidth="md">
          <DialogTitle>Sign In</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {errorMsg?.message
                ? errorMsg?.message
                : `Please fill in all appropraite filds`}
            </DialogContentText>

            <Box>
              <Paper p={2} elevation={2}>
                <Box
                  sx={{ p: 2 }}
                  component="form"
                  id="loginForm"
                  onSubmit={handleLoginSubmit}
                >
                  <Box py={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <Email
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            id="input-with-sx"
                            label="Email"
                            variant="standard"
                            fullWidth
                            onChange={handleChange}
                            value={logs.email}
                            type="email"
                            name="email"
                            helperText={errorMsg?.email}
                            required
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                          <Password
                            sx={{ color: "action.active", mr: 1, my: 0.5 }}
                          />
                          <TextField
                            required
                            id="input-with-sx"
                            label="Password "
                            variant="standard"
                            fullWidth
                            type="password"
                            onChange={handleChange}
                            value={logs.password}
                            name="password"
                            helperText={errorMsg?.password}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Link
                      underline="none"
                      button
                      component="button"
                      type="button"
                      onClick={handleOpenForgotPassword}
                    >
                      Forgot password ?
                    </Link>
                    <Button variant="outlined" size="large" type="submit">
                      Login
                    </Button>
                    <Link
                      underline="none"
                      button
                      component="button"
                      type="button"
                      onClick={() => dispatch(toggleSignUp())}
                    >
                      have an account ? Sign Up
                    </Link>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleOpenLogin} color="error" variant="outlined">
              Close
            </Button>
          </DialogActions>
        </Container>
      </SwipeableDrawer>
      <ForgotPassword />
    </>
  );
};

export default Login;
